
document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".copy_plate .copy-text").forEach(el => {
        if(!el){
            return false;
        }
        const tooltip = el.querySelector(".copy-tooltip");

        el.addEventListener("click", () => {
            const textToCopy = el.querySelector(".copy-text-content").getAttribute("data-copy");
            navigator.clipboard.writeText(textToCopy).then(() => {

                tooltip.classList.add("show");

                setTimeout(() => {
                    tooltip.classList.remove("show");
                }, 1500);
            }).catch(err => {
                console.error("Copy failed:", err);
            });
        });
    });
});